<template>
  <section id="dashboard-analytics">




    <b-row class="match-height">
      <b-col
          cols="12"

      >
        <b-card
            v-if="common.statisticsItems"
            no-body
            class="card-statistics"
        >

          <b-card-body class="statistics-body">
            <b-row>
              <b-col
                class="mt-2"

                  cols="6"

              >
                <b-media no-body>
                  <b-media-aside

                      class="mr-2"
                  >
                    <b-avatar
                        size="48"
                        :variant="'success'"
                    >
                      <feather-icon
                          size="30"
                          :icon="'UsersIcon'"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{statis.numberOfUser}}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      تعداد کل کاربران
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col

                  class="mt-2"
                  cols="6"

              >
                <b-media no-body>
                  <b-media-aside

                      class="mr-2"
                  >
                    <b-avatar
                        size="48"
                        :variant="'warning'"
                    >
                      <feather-icon
                          size="30"
                          :icon="'UserPlusIcon'"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statis.numberOfUserToday }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      تعداد کاربران جدید ثبت شده (امروز)
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col

                  cols="6"
                  class="mt-3"
              >
                <b-media no-body>
                  <b-media-aside

                      class="mr-2"
                  >
                    <b-avatar
                        size="48"
                        :variant="'danger'"
                    >
                      <feather-icon
                          size="30"
                          :icon="'AwardIcon'"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statis.numberOfUserSubscription }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      تعداد کل اشتراک های ثبت شده
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              <b-col

                  cols="6"
                  class="mt-3"
              >
                <b-media no-body>
                  <b-media-aside

                      class="mr-2"
                  >
                    <b-avatar
                        size="48"
                        :variant="'primary'"
                    >
                      <feather-icon
                          size="30"
                          :icon="'KeyIcon'"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statis.numberOfUserSubscriptionToday }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      تعداد اشتراک های ثبت شده امروز
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                  cols="6"
                  class="mt-4"
              >
                <ecommerce-browser-states :android="statis.numberOfAndroid" :ios="statis.numberOfIos"/>

              </b-col>

            </b-row>
          </b-card-body>
        </b-card>

      </b-col>


      <!-- Browser States Card -->

      <!--/ Browser States Card -->

    </b-row>





<!--    <b-row class="match-height">-->
<!--      <b-col-->
<!--        cols="6"-->
<!--      >-->
<!--        <statistic-card-with-area-chart-->
<!--          v-if="data.subscribersGained"-->
<!--          icon="UsersIcon"-->
<!--          :statistic="kFormatter(data.subscribersGained.analyticsData.subscribers)"-->
<!--          statistic-title="تعداد کاربران"-->
<!--          :chart-data="data.subscribersGained.series"-->
<!--        />-->
<!--      </b-col>-->
<!--      <b-col-->
<!--      cols="6"-->
<!--      >-->
<!--        <statistic-card-with-area-chart-->
<!--            v-if="data.ordersRecevied"-->
<!--            icon="FactoryIcon"-->
<!--            color="success"-->
<!--            :statistic="kFormatter(data.ordersRecevied.analyticsData.orders)"-->
<!--            statistic-title="تعداد کاربران فعال"-->
<!--            :chart-data="data.ordersRecevied.series"-->
<!--        />-->
<!--      </b-col>-->
<!--      <b-col-->
<!--        cols="4"-->
<!--      >-->
<!--        <statistic-card-with-area-chart-->
<!--          v-if="data.ordersRecevied"-->
<!--          icon="PackageIcon"-->
<!--          color="danger"-->
<!--          :statistic="kFormatter(data.ordersRecevied.analyticsData.orders)"-->
<!--          statistic-title="تعداد کاربران جدید (امروز)"-->
<!--          :chart-data="data.ordersRecevied.series"-->
<!--        />-->
<!--      </b-col>-->
<!--      <b-col-->
<!--          cols="4"-->
<!--      >-->
<!--        <statistic-card-with-area-chart-->
<!--            v-if="data.ordersRecevied"-->
<!--            icon="TruckIcon"-->
<!--            color="warning"-->
<!--            :statistic="kFormatter(data.ordersRecevied.analyticsData.orders)"-->
<!--            statistic-title="تعداد کاربران جدید فعال (فعال)"-->
<!--            :chart-data="data.ordersRecevied.series"-->
<!--        />-->
<!--      </b-col>-->
<!--      <b-col lg="4">-->
<!--        <ecommerce-earnings-chart :data="common.earningsChart" />-->
<!--      </b-col>-->
<!--    </b-row>-->






    <b-row class="match-height">




      <b-col lg="12">
        <analytics-avg-sessions :data="data.avgSessions" />
      </b-col>



<!--      <b-col lg="6">-->
<!--        <analytics-support-tracker :data="data.supportTracker" />-->
<!--      </b-col>-->
    </b-row>

<!--    <b-row class="match-height">-->
<!--      <b-col lg="4">-->
<!--        <analytics-timeline :data="data.timeline" />-->
<!--      </b-col>-->
<!--      <b-col lg="4">-->
<!--        <analytics-sales-radar-chart :data="data.salesChart" />-->
<!--      </b-col>-->
<!--      <b-col lg="4">-->
<!--        <analytics-app-design :data="data.appDesign" />-->
<!--      </b-col>-->
<!--    </b-row>-->

<!--    <b-row>-->
<!--      <b-col cols="12">-->
<!--        <invoice-list />-->
<!--      </b-col>-->
<!--    </b-row>-->
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BAvatar,
  BMediaAside, BMediaBody
} from 'bootstrap-vue'
import galleryRepository from '@/modules/gallery/services/galleryRepository'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import AnalyticsCongratulation from './AnalyticsCongratulation.vue'
import AnalyticsAvgSessions from './AnalyticsAvgSessions.vue'
import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
import AnalyticsTimeline from './AnalyticsTimeline.vue'
import DashboardRepository from '../dashboardRepository'

import AnalyticsSalesRadarChart from './AnalyticsSalesRadarChart.vue'
import AnalyticsAppDesign from './AnalyticsAppDesign.vue'
import EcommerceEarningsChart from "@/views/dashboard/ecommerce/EcommerceEarningsChart";
import EcommerceBrowserStates from "@/views/dashboard/ecommerce/EcommerceBrowserStates";
import categoryRepository from '@/modules/categories/services/categoryRepository'
import contentRepository from '@/modules/contents/services/contentRepository'
import { $appConfig } from '../../../../appConfig'

export default {
  components: {
    BRow,
    BCol,
    AnalyticsCongratulation,
    AnalyticsAvgSessions,
    StatisticCardWithAreaChart,
    AnalyticsSupportTracker,
    EcommerceEarningsChart,
    AnalyticsTimeline,
    AnalyticsSalesRadarChart,
    AnalyticsAppDesign,
    InvoiceList,
    BCard,
    BCardHeader,
    BCardTitle,
    EcommerceBrowserStates,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,

  },
  data() {
    return {
      data: {},
      common:{},
      statis:{
        numberOfUser: 0,
        numberOfUserSubscription: 0,
        numberOfUserToday: 0,
        numberOfUserSubscriptionToday: 0,
        numberOfAndroid: 0,
        numberOfIos: 0
      }
    }
  },
  async created() {


    const {data} = await DashboardRepository.get('');
    if (data.isSuccess) {
      this.statis.numberOfUser = data.data.numberOfUser
      this.statis.numberOfUserSubscription = data.data.numberOfUserSubscription
      this.statis.numberOfUserToday = data.data.numberOfUserToday
      this.statis.numberOfUserSubscriptionToday = data.data.numberOfUserSubscriptionToday
    }

    await this.getCommentCount();
    await this.getGalleyCommentCount();




    // data
    this.$http.get('/analytics/data')
      .then(response => { this.data = response.data })

    this.$http.get('/ecommerce/data')
        .then(response => {
              this.common = response.data})
  },
  methods: {
    kFormatter,
    async getCommentCount() {
      const { data } = await contentRepository.getCommentCount('');

      if (data.isSuccess){
        localStorage.setItem('commentsCount' , data.data);
        $appConfig.commentCount = data.data;
      }

    },
    async getGalleyCommentCount() {
      const { data } = await galleryRepository.getCommentCount('');

      if (data.isSuccess){
        localStorage.setItem('galleryCommentsCount' , data.data);
        // $appConfig.commentCount = data.data;
      }

    }
  },
}
</script>
